import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactQuill from 'react-quill'
import { sendMail } from '../../store/action/patient.action'
import '../../css/patient.scss'
import 'react-quill/dist/quill.snow.css'
import { Modal, Card, Form, Input, message } from 'antd'
import util from '../../util/util'
import Session from '../../util/sessionstore'
import { updateSignature } from '../../store/action/user.action'
import { constants } from '../../constants'

// var form = undefined;
var session = new Session()

const PatientMail = (props) => {
  var form = useRef()

  useEffect(() => {
    form.current &&
      form.current.setFieldsValue({
        to: '',
        subject: constants.MAIL.SUBJECT(
          props.mail?.firstname + ' ' + props.mail?.lastname
        ),
        text: constants.MAIL.MESSAGE,
        signature: props.user.signature,
      })
  }, [props.mail])

  var handleCancel = () => {
    form.current &&
      form.current.setFieldsValue({
        to: '',
        subject: constants.MAIL.SUBJECT(
          props.mail?.firstname + ' ' + props.mail?.lastname
        ),
        text: constants.MAIL.MESSAGE,
        signature: props.user.signature,
      })
    props.onCancel()
  }

  var handleSend = () => {
    form.current.validateFields().then((values) => {
      values.signature != props.user.signature &&
        props.updateSignature(values.signature, props.user)
      props.sendMail({ ...values, patientid: props.mail?.key }).then((flag) => {
        if (flag) {
          form.current.setFieldsValue({
            to: '',
            subject: constants.MAIL.SUBJECT(
              props.mail?.firstname + ' ' + props.mail?.lastname
            ),
            text: constants.MAIL.MESSAGE,
            signature: props.user.signature,
          })
          props.onCancel()
        }
      })
    })
  }

  var renderBody = () => {
    return (
      <Card bordered={false}>
        <Form
          ref={form}
          name='normal_login'
          layout={'vertical'}
          initialValues={{
            to: '',
            subject: constants.MAIL.SUBJECT(
              props.mail?.firstname + ' ' + props.mail?.lastname
            ),
            text: constants.MAIL.MESSAGE,
            signature: props.user.signature,
          }}
        >
          <Form.Item
            className='form-item-mail'
            name='to'
            label='To'
            rules={[
              { required: true, message: 'Please input your Email!' },
              { type: 'email', message: 'Please enter valid email! ' },
            ]}
          >
            <Input type='email' placeholder='Email' />
          </Form.Item>
          <Form.Item
            className='form-item-mail'
            name='subject'
            label='Subject'
            rules={[
              {
                required: true,
                message: 'Please input your Subject!',
              },
            ]}
          >
            <Input placeholder='Subject' />
          </Form.Item>
          <Form.Item
            className='form-item-mail'
            name='text'
            label='Message'
            rules={[
              {
                required: true,
                message: 'Please confirm your Text!',
              },
            ]}
          >
            {/* <Input.TextArea allowClear rows={4}/> */}
            <ReactQuill
              formats={PatientMail.formats}
              modules={PatientMail.modules}
            />
          </Form.Item>
          <Form.Item
            className='form-item-mail'
            name='signature'
            label='Complimentary Close'
            rules={[
              {
                required: true,
                message: 'Please confirm your Text!',
              },
            ]}
          >
            <ReactQuill
              formats={PatientMail.formats}
              modules={PatientMail.modules}
            />
          </Form.Item>
        </Form>
        <i>
          <b>*Link for the patient report will be added to this email.*</b>
        </i>
      </Card>
    )
  }

  return (
    <Modal
      className={'filterModal'}
      visible={props.mail}
      closable={false}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleSend}
      width={'70%'}
    >
      {renderBody()}
    </Modal>
  )
}

PatientMail.propTypes = {
  user: PropTypes.object,
  updateSignature: PropTypes.func.isRequired,
}

PatientMail.modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    [{ color: [] }, { background: [] }],
    ['link', 'image'],
    ['clean'],
  ],
  clipboard: {
    matchVisual: true,
  },
}

PatientMail.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'color',
  'background',
  'link',
  'image',
]

const mapStateToProps = (state) => {
  return {
    user: state.profile.user,
    mailError: state.patient.mailError,
    mailMessage: state.patient.mailMessage,
    user: state.profile.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendMail: (params) => dispatch(sendMail(params)),
    updateSignature: (signature, user) =>
      dispatch(updateSignature(signature, user)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientMail)
